import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { Heading, Text } from "@cinch-labs/design-system";
import { storyblokEditable } from "@cinch-nx/data-storyblok";
import styles from "./delivery-collect.module.css";
import DeliveryOptionCard from "./option-card";
export const DeliveryCollectSection = (blok)=>{
    const { heading , body , options  } = blok;
    return /*#__PURE__*/ _jsxs("section", {
        ...storyblokEditable(blok),
        className: styles.wrapper,
        children: [
            /*#__PURE__*/ _jsx(Heading, {
                className: styles.heading,
                children: heading
            }),
            /*#__PURE__*/ _jsx(Text, {
                className: styles.body,
                children: body
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.options,
                children: options === null || options === void 0 ? void 0 : options.map((option)=>/*#__PURE__*/ _createElement(DeliveryOptionCard, {
                        ...option,
                        key: option._uid
                    }))
            })
        ]
    });
};
export default DeliveryCollectSection;
